module.exports = __webpack_public_path__ + "static/media/fuel.b7b4a6d4.svg";